import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from "react";
import { useBitKeepDetection } from "@/hooks/useBitKeepDetection";
import Image from "next/image";
import Button from "../basic/Button";
// tracker
import { tracker } from "@/track";
//assets
import BitgetWallet from "@/assets/images/BitgetWallet.webp";
//
import { openSafeWindow } from "@bit/utils";
const AppOpenBanner = (param)=>{
    let { appName = "Bitget Wallet", className = "", stickyOffset = 0, utmSource = "appTop" } = param;
    const [isSticky, setIsSticky] = useState(false);
    const bannerRef = useRef(null);
    const observerRef = useRef(null);
    const isBitkeep = useBitKeepDetection();
    const t = useTranslations("");
    const handleOpenApp = ()=>{
        const currentUrl = window.location.href;
        if (!isBitkeep) {
            tracker.click("b6429", {
                id: "",
                url: currentUrl,
                utmSource: utmSource,
                click_type: "open_in_app"
            });
            const deep_link = "https://web3.bitget.cloud/wallet-download?type=0&deep_link_value=bitkeep://webview?url=".concat(currentUrl);
            openSafeWindow(deep_link, "_blank");
            return false;
        }
        return true;
    };
    useEffect(()=>{
        var _banner_parentNode;
        const banner = bannerRef.current;
        if (!banner) return;
        // 创建一个占位元素，用于观察原始位置
        const sentinel = document.createElement("div");
        (_banner_parentNode = banner.parentNode) === null || _banner_parentNode === void 0 ? void 0 : _banner_parentNode.insertBefore(sentinel, banner);
        observerRef.current = new IntersectionObserver((param)=>{
            let [entry] = param;
            setIsSticky(!entry.isIntersecting);
        }, {
            threshold: 1,
            rootMargin: "-".concat(stickyOffset, "px 0px 0px 0px")
        });
        observerRef.current.observe(sentinel);
        return ()=>{
            var _observerRef_current;
            (_observerRef_current = observerRef.current) === null || _observerRef_current === void 0 ? void 0 : _observerRef_current.disconnect();
            sentinel.remove();
        };
    }, [
        stickyOffset
    ]);
    useEffect(()=>{
        const currentUrl = window.location.href;
        if (!isBitkeep) {
            tracker.expose("b6428", {
                id: "",
                url: currentUrl,
                utmSource: utmSource
            });
        }
    }, []);
    return !isBitkeep && /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            isSticky && /*#__PURE__*/ _jsx("div", {
                className: "h-[44px]"
            }),
            /*#__PURE__*/ _jsx("div", {
                ref: bannerRef,
                className: "  \n          w-full px-[20px] py-[8px] bg-[var(--bg-0)]  \n          ".concat(isSticky ? "  \n            fixed top-0 left-0 right-0   \n            shadow-sm  \n            z-50  \n          " : "", "  \n          ").concat(className, "  \n        "),
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "w-full flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex items-center space-x-3",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex items-center",
                                children: [
                                    /*#__PURE__*/ _jsx(Image, {
                                        width: 28,
                                        height: 28,
                                        src: BitgetWallet.src,
                                        alt: appName,
                                        loading: "lazy",
                                        className: "mr-[6px]"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "text-base font-bold text-[18px] text-[var(--text-1)]",
                                        children: appName
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            size: "sm",
                            onClick: handleOpenApp,
                            className: "text-[12px] BTstyle",
                            children: t("openInApp")
                        })
                    ]
                })
            })
        ]
    });
};
export default AppOpenBanner;
